import { PropsWithChildren } from 'react'
import classNames from 'classnames'

import { FragmentType, gql, useFragment } from 'graphql-generated'
import { GetText } from 'lib/gettext'

import Entry from './entry'

const CONTRIBUTIONS_FRAGMENT = gql(`
  fragment PublicProfile_Contributions on auth_user {
    entries(where: { _and: [{ progress: { published: { _gt: 0 } } }, { archived: { _eq: false } }] }) {
      id
      ...PublicProfile_Contributions_Entry
    }
  }
`)

type ContributionsProps = {
  userRef: FragmentType<typeof CONTRIBUTIONS_FRAGMENT>
  className?: string
}

type TableHeaderProps = PropsWithChildren<{
  className?: string
  colSpan?: number
}>

function TableHeader(props: TableHeaderProps) {
  const { children, colSpan, className } = props

  return (
    <th
      className={classNames(
        'border-b border-gray-300 py-2 px-3 text-left text-xs font-normal text-muted first:pl-0 last:pr-0',
        className
      )}
      colSpan={colSpan}
    >
      {children}
    </th>
  )
}

export default function Contributions(props: ContributionsProps) {
  const { entries } = useFragment(CONTRIBUTIONS_FRAGMENT, props.userRef)

  if (entries.length > 0) {
    return (
      <>
        <h3 className="mb-2 text-lg font-semibold capitalize">
          <GetText>Database contributions</GetText>
        </h3>
        <table className={classNames('w-full table-auto', props.className)}>
          <thead>
            <tr>
              <TableHeader className="w-6/12">
                <GetText>Entry name</GetText>
              </TableHeader>
              <TableHeader colSpan={2} className="!px-0">
                <GetText>Progress</GetText>
              </TableHeader>
              <TableHeader className="w-1/3">
                <GetText>Published</GetText>
              </TableHeader>
              <TableHeader className="whitespace-nowrap">
                <GetText>Date modified</GetText>
              </TableHeader>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <Entry key={entry.id} entryRef={entry} />
            ))}
          </tbody>
        </table>
      </>
    )
  }

  return (
    <p className="text-center text-xl text-muted">
      <GetText>There are currently no entries linked to this account</GetText>
    </p>
  )
}
